/* Persist collection grid view beyond session (localStorage)
   Safe: does not modify theme components; just syncs choice.
   2026-02-18
*/

(function () {
  const KEY_DESKTOP = 'coqagri-product-grid-view-desktop';
  const KEY_MOBILE = 'coqagri-product-grid-view-mobile';

  function isLarge() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function syncFromLocalToSession() {
    try {
      const desktop = localStorage.getItem(KEY_DESKTOP);
      const mobile = localStorage.getItem(KEY_MOBILE);
      if (desktop) sessionStorage.setItem('product-grid-view-desktop', desktop);
      if (mobile) sessionStorage.setItem('product-grid-view-mobile', mobile);
    } catch (_) {}
  }

  function applyCheckedFromStorage() {
    // Let theme initialize first; then nudge inputs.
    const viewport = isLarge() ? 'desktop' : 'mobile';
    const sessionKey = `product-grid-view-${viewport}`;

    let value = null;
    try {
      value = sessionStorage.getItem(sessionKey);
      if (!value) {
        value = isLarge() ? localStorage.getItem(KEY_DESKTOP) : localStorage.getItem(KEY_MOBILE);
      }
    } catch (_) {}

    if (!value) return;

    const selector = viewport === 'desktop'
      ? `input.column-options__option-input[name="grid"][value="${CSS.escape(value)}"]`
      : `input.column-options__option-input[name="grid-mobile"][value="${CSS.escape(value)}"]`;

    const input = document.querySelector(selector);
    if (input) input.checked = true;
  }

  function onChange(e) {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.classList.contains('column-options__option-input')) return;

    const viewport = t.name === 'grid' ? 'desktop' : (t.name === 'grid-mobile' ? 'mobile' : null);
    if (!viewport) return;

    try {
      if (viewport === 'desktop') localStorage.setItem(KEY_DESKTOP, t.value);
      if (viewport === 'mobile') localStorage.setItem(KEY_MOBILE, t.value);
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncFromLocalToSession();
    // Apply after a tick to avoid racing with theme scripts.
    setTimeout(applyCheckedFromStorage, 50);
    document.addEventListener('change', onChange, true);
  });
})();
